import { useEffect, useState } from "react";
import useSWR, { type SWRResponse } from "swr";
import { useApiClient } from "@/hooks/useApiClient";
import {
  CORPORATE_MASTER_SUGGEST_API_PATH,
  getCorporateMasterSuggest,
} from "../api";
import type { CorporateSuggestResponse } from "../types";

const SUGGEST_DEBOUNCE_MS = 300;
// BE は索引（3文字単位）が効かない短い入力では候補を返さないため、3文字未満ではリクエストしない
const SUGGEST_MIN_LENGTH = 3;

/**
 * 法人名のサジェスト候補を取得する（入力は300msデバウンス）
 * @param input 入力中の法人名
 * @param limit 最大件数
 * @returns SWRレスポンス。3文字未満ではリクエストしない
 */
export const useCorporateMasterSuggest = (
  input: string,
  limit = 10
): SWRResponse<CorporateSuggestResponse, Error> => {
  const { apiClient } = useApiClient();
  const [query, setQuery] = useState("");
  useEffect(() => {
    const timer = window.setTimeout(() => {
      setQuery(input.trim());
    }, SUGGEST_DEBOUNCE_MS);
    return () => {
      window.clearTimeout(timer);
    };
  }, [input]);
  return useSWR<CorporateSuggestResponse, Error>(
    query.length >= SUGGEST_MIN_LENGTH
      ? [CORPORATE_MASTER_SUGGEST_API_PATH, query, limit]
      : null,
    async () => await getCorporateMasterSuggest(apiClient, query, limit),
    { revalidateOnFocus: false }
  );
};
